// extracted by mini-css-extract-plugin
module.exports = {"quantitySelector":"PKyAU","quantitySelector-container":"jyned","quantity-content":"ZFtWW","quantity-btn":"zgeIJ"};